var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chartData)?_c('v-sheet',{staticClass:"pa-2",attrs:{"rounded":"","color":"#ffffffe0"}},[_c('LineChartGenerator',{staticStyle:{"height":"220px","width":"100%"},attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }